export function InfoSmallOutlinedIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_9845_75872)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.00156 1.6501C4.49455 1.6501 1.65156 4.49309 1.65156 8.0001C1.65156 11.5071 4.49455 14.3501 8.00156 14.3501C11.5086 14.3501 14.3516 11.5071 14.3516 8.0001C14.3516 4.49309 11.5086 1.6501 8.00156 1.6501ZM0.351562 8.0001C0.351562 3.77512 3.77658 0.350098 8.00156 0.350098C12.2265 0.350098 15.6516 3.77512 15.6516 8.0001C15.6516 12.2251 12.2265 15.6501 8.00156 15.6501C3.77658 15.6501 0.351562 12.2251 0.351562 8.0001Z'
          fill='#B2BDD6'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.10156 5.33359C7.10156 4.83654 7.50451 4.43359 8.00156 4.43359H8.00908C8.50613 4.43359 8.90908 4.83654 8.90908 5.33359C8.90908 5.83065 8.50613 6.23359 8.00908 6.23359H8.00156C7.50451 6.23359 7.10156 5.83065 7.10156 5.33359Z'
          fill='#B2BDD6'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.68359 8.0001C6.68359 7.64111 6.97461 7.3501 7.33359 7.3501H8.00026C8.35925 7.3501 8.65026 7.64111 8.65026 8.0001V10.0168H8.66693C9.02591 10.0168 9.31693 10.3078 9.31693 10.6668C9.31693 11.0257 9.02591 11.3168 8.66693 11.3168H8.00026C7.64128 11.3168 7.35026 11.0257 7.35026 10.6668V8.6501H7.33359C6.97461 8.6501 6.68359 8.35908 6.68359 8.0001Z'
          fill='#B2BDD6'
        />
      </g>
      <defs>
        <clipPath id='clip0_9845_75872'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
